import './axios'
import './graph'
import './chartist'
import './vee-validate'
import vuetify from './vuetify'

export default {
  vuetify
}
